import { Card, Text } from '@fluentui/react-components';

import { useEmptyStateMessageStyles } from './EmptyStateMessage.styles';

interface EmptyStateMessageProps {
  message: string
  actionElement?: React.ReactNode
}

const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({
  message,
  actionElement,
}) => {
  const styles = useEmptyStateMessageStyles();

  return (
    <Card
      className={styles.container}
      data-testid="empty-state-message"
    >
      <Text block className={styles.message}>
        {message}
      </Text>

      {actionElement}
    </Card>
  );
};

export default EmptyStateMessage;
